import { AxiosError } from 'axios';
import { useAxiosQuery } from 'hooks/useAxiosQuery';
import { BLUEPRINT_SHARED_TOKEN_CACHE_KEY } from 'services/queryKeys';
import { SharedBlueprintToken } from 'types';

type UseGetSharedBlueprintTokenProps = {
  blueprintId: string | number;
  enabled?: boolean;
};

export const useGetSharedBlueprintToken = ({ blueprintId, enabled = true }: UseGetSharedBlueprintTokenProps) => {
  const {
    data: sharedTokensArray,
    isLoading,
    isError,
    error,
    refetch,
  } = useAxiosQuery<SharedBlueprintToken[]>(
    BLUEPRINT_SHARED_TOKEN_CACHE_KEY(blueprintId),
    `/blueprints/${blueprintId}/share/`,
    {
      enabled: enabled && !!blueprintId,
      retry: false,
      onError: (error: AxiosError) => {
        if (error?.response?.status !== 404) {
          console.error('Error fetching shared blueprint token:', error);
        }
      },
    }
  );

  // API returns an array of tokens, take the last one (most recent)
  const normalizedToken =
    Array.isArray(sharedTokensArray) && sharedTokensArray.length > 0
      ? sharedTokensArray[sharedTokensArray.length - 1]
      : null;

  return {
    sharedToken: normalizedToken,
    isLoading,
    isError,
    error,
    refetch,
  };
};
